function entryId(entry) {
  return String(entry?.id || entry?._id || "");
}

export async function captureOwnerInboxEntry(api, payload = {}) {
  if (!api?.createLifeEntry) throw new Error("Owner Inbox API no disponible.");
  const text = String(payload.text || "").trim();
  if (!text) throw new Error("La entrada del Inbox no puede quedar vacía.");

  return api.createLifeEntry({
    ...payload,
    text,
    kind: payload.kind || "unknown",
    inputSource: payload.inputSource || "text",
    tzOffsetMinutes: payload.tzOffsetMinutes ?? new Date().getTimezoneOffset(),
  });
}

export async function resolveOwnerInboxEntry(api, entry, {
  status = "resolved",
  kind = "manual",
  entityType = "",
  entityId = "",
  note = "",
  initiativeId = "",
  clientId = "",
  entryKind,
} = {}) {
  if (!api?.updateLifeEntry) throw new Error("Owner Inbox API no disponible.");
  const id = entryId(entry);
  if (!id) throw new Error("La entrada del Inbox no es válida.");

  return api.updateLifeEntry(id, {
    status,
    ...(entryKind ? { kind: entryKind } : {}),
    resolutionKind: kind,
    resolutionEntityType: entityType,
    resolutionEntityId: entityId,
    resolutionNote: note,
    resolutionInitiativeId: initiativeId || null,
    resolutionClientId: clientId || null,
  });
}

export async function convertOwnerInboxToCommitment(api, entry, payload = {}) {
  if (!api?.createCommitment) throw new Error("Owner Inbox API no disponible.");
  const id = entryId(entry);
  const title = String(payload.title || entry?.text || "").trim();
  if (!id || !title) throw new Error("La entrada del Inbox no es válida.");

  return api.createCommitment({
    title,
    kind: payload.kind || "task",
    priority: payload.priority || "normal",
    dueAt: payload.dueAt || null,
    scheduledStartAt: payload.scheduledStartAt || null,
    estimatedMinutes: payload.estimatedMinutes || null,
    initiativeId: payload.initiativeId || null,
    clientId: payload.clientId || null,
    work: payload.work || undefined,
    notes: payload.notes || "Creado desde el procesador del Inbox.",
    sourceEntryId: id,
    source: { kind: entry?.inputSource || "manual" },
  });
}

export async function recordOwnerInboxRetrospective(api, entry, payload = {}) {
  if (!api?.resolveLifeEntryRetrospective) throw new Error("Owner retrospective API no disponible.");
  const id = entryId(entry);
  if (!id) throw new Error("La entrada del Inbox no es válida.");
  return api.resolveLifeEntryRetrospective(id, payload);
}
